/**
 * Коды ошибок API. Единственный перечень — здесь.
 * Новый код добавляется сюда, а не строкой в хендлере: иначе клиент о нём
 * не узнает и не сможет отреагировать осмысленно.
 *
 * Полное описание — `docs/04-api.md`.
 */
export const ERROR_CODES = {
    BAD_REQUEST: 'BAD_REQUEST',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    PHONE_REQUIRED: 'PHONE_REQUIRED',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    INVALID_TRANSITION: 'INVALID_TRANSITION',
    SLOT_UNAVAILABLE: 'SLOT_UNAVAILABLE',
    PRODUCT_UNAVAILABLE: 'PRODUCT_UNAVAILABLE',
    VENDOR_UNAVAILABLE: 'VENDOR_UNAVAILABLE',
    PAYMENT_NOT_CONFIRMED: 'PAYMENT_NOT_CONFIRMED',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    ZONE_NOT_COVERED: 'ZONE_NOT_COVERED',
    INVALID_GEOMETRY: 'INVALID_GEOMETRY',
    TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
    INTERNAL: 'INTERNAL',
};
/** HTTP-статус, соответствующий коду. */
export const ERROR_HTTP_STATUS = {
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    PHONE_REQUIRED: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    INVALID_TRANSITION: 409,
    SLOT_UNAVAILABLE: 409,
    PRODUCT_UNAVAILABLE: 409,
    VENDOR_UNAVAILABLE: 409,
    PAYMENT_NOT_CONFIRMED: 409,
    VALIDATION_FAILED: 422,
    ZONE_NOT_COVERED: 422,
    INVALID_GEOMETRY: 422,
    TOO_MANY_REQUESTS: 429,
    INTERNAL: 500,
};
/**
 * Ошибка, которую хендлеры бросают осознанно.
 * Всё остальное, что долетит до обработчика, считается внутренней ошибкой
 * и наружу отдаётся как INTERNAL без подробностей.
 */
export class HttpError extends Error {
    code;
    status;
    fields;
    constructor(code, message, fields = null) {
        super(message);
        this.name = 'HttpError';
        this.code = code;
        this.status = ERROR_HTTP_STATUS[code];
        this.fields = fields;
    }
    toBody() {
        return { error: { code: this.code, message: this.message, fields: this.fields } };
    }
}
//# sourceMappingURL=errors.js.map